import { render, staticRenderFns } from "./UploadAvatarDialog.vue?vue&type=template&id=24f260a3&"
import script from "./UploadAvatarDialog.vue?vue&type=script&lang=js&"
export * from "./UploadAvatarDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadAvatarDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports